import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewQueryParams } from '@app/core/list-view/types';
import { Paginated } from '@mi-front/core';
import { CuepointDto } from './api/youtube-cuepoints-api.types';
import { fetchYoutubeCuepoints } from './api/fetch-youtube-cuepoints';
import { YOUTUBE_CUEPOINTS_FILTERS_CONFIG } from './filters/youtube-cuepoints-filters-config';
import { InsertCuepointButton } from './insert-cuepoint/InsertCuepointButton';
import { YoutubeCuepointsTable } from './YoutubeCuepointsTable';

interface Props {
  stationId: string;
}

/**
 * ListView-backed cuepoints list for a station via youtube-integration `/cuepoints`.
 */
export function YoutubeCuepointsList({ stationId }: Props) {
  const timezone = useTimezone();
  const listId = `youtube-cuepoints-${stationId}`;

  const queryFn = async (params: ListViewQueryParams): Promise<Paginated<CuepointDto>> => {
    return fetchYoutubeCuepoints(stationId, params, timezone);
  };

  return (
    <ListView
      listId={listId}
      queryFn={queryFn}
      filters={YOUTUBE_CUEPOINTS_FILTERS_CONFIG}
      actions={[
        <InsertCuepointButton key="insert-cuepoint" stationId={stationId} listId={listId} />,
      ]}
      ListComponent={YoutubeCuepointsTable}
      defaultPageSize={50}
    />
  );
}
